const getters = {
  getData: (state) => (key) => state.data[key],
};

export default getters;
